module.exports = __webpack_public_path__ + "img/toExamined1.55da17ea.png";